<template>
	<CatchmentComparisonDialog v-model="open" :overlay-target="overlayTarget" :context="context" />
</template>

<script setup>
// Persistent zone (mirrors src/components/points/PointsDialogZone.vue) — mounted once at startup,
// opens the comparison dialog on a plain window CustomEvent dispatched from iframeWatcher.js in
// response to the legacy relevé's "Comparer" button (OPEN_CATCHMENT_COMPARISON postMessage).
import { ref, inject, onMounted, onBeforeUnmount } from 'vue';
import CatchmentComparisonDialog from './CatchmentComparisonDialog.vue';

const overlayTarget = inject('overlayTarget', null);
const open = ref(false);
const context = ref(null);

function handleOpen(event) {
	context.value = event?.detail ?? null;
	open.value = true;
}

onMounted(() => {
	window.addEventListener('open-vue-catchment-comparison', handleOpen);
});

onBeforeUnmount(() => {
	window.removeEventListener('open-vue-catchment-comparison', handleOpen);
});
</script>
